import bfTabsPane from './bf-tabs-pane.vue';
bfTabsPane.install = Vue => Vue.component(bfTabsPane.name,bfTabsPane);
export default bfTabsPane;



// WEBPACK FOOTER //
// ./src/packages/tabs/bf-tabs-pane/index.js